import { render } from "./RegisterSeller.vue?vue&type=template&id=20e18298"
import script from "./RegisterSeller.vue?vue&type=script&lang=js"
export * from "./RegisterSeller.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__